import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/ebitda-calculator',
  component: () => import('../../routes/EbitdaCalculator.svelte'),
  card: {
    id: 'ebitda-calculator',
    title: 'EBITDA Calculator',
    description:
      'Calculate EBITDA and EBITDA margin from revenue, COGS, operating expenses, and depreciation. Measure business profitability.',
    icon: 'analytics',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/ebitda-calculator',
    category: 'Business',
  },
  seo: {
    title: 'EBITDA Calculator – Business Profitability & EBITDA Margin Calculator',
    description:
      'Free EBITDA calculator to measure business profitability. Enter revenue, COGS, operating expenses, and depreciation & amortization to calculate EBITDA and EBITDA margin. Understand operating efficiency with our free online calculator.',
  },
};

export default meta;
